import React, { createContext, useCallback, useContext, useState } from "react";
import { Spin } from "antd";

const BackdropContext = createContext(null);

export function useBackdrop() {
  return useContext(BackdropContext);
}

export const BackdropProvider = ({ children }) => {
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [backdropMessage, setBackdropMessage] = useState("");

  const openBackdrop = useCallback(message => {
    setBackdropMessage(message);
    setBackdropOpen(true);
  }, []);

  const closeBackdrop = useCallback(() => {
    setBackdropOpen(false);
    setBackdropMessage("");
  }, []);

  return (
    <BackdropContext.Provider value={{ openBackdrop, closeBackdrop }}>
      {children}
      {backdropOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1300,
            color: "#fff",
          }}
        >
          <Spin size="large" />
          {backdropMessage && (
            <div style={{ marginTop: 16, fontSize: "1.25rem", fontWeight: 500 }}>
              {backdropMessage}
            </div>
          )}
        </div>
      )}
    </BackdropContext.Provider>
  );
};
